// ScheduleHero's public contact address. Shared by the marketing site
// (footer, "Email us for a demo") and the dashboard's Help & Feedback link.
// Kept in its own dependency-free module so the dashboard does not pull in
// the marketing chrome to read it.

export const CONTACT_EMAIL = 'Hello@scheduleheroai.com';
